export const ThumbnailTypeMap = {
  TRACK: 'COURSE',
  COURSE: 'COURSE',
  LESSON: 'LESSON',
  PLAYLIST: 'PLAYLIST',
  LEARNING_PATH: 'HUBSPOT_PLAYLIST',
  SHORT_FORM_CONTENT: 'VIDEO',
  LIVE_EVENT: 'LIVE_EVENT'
};